// Internationalization strings for English, Hindi, Spanish, and Arabic

export const translations = {
  en: {
    // Landing Page
    hero_title: "Manage projects. Efficiently.",
    hero_subtitle: "Create projects and tasks using voice or simple language.",
    cta_primary: "Start with AI – Free",
    cta_secondary: "Watch Demo",
    proof_1_title: "AI-Powered",
    proof_1_desc: "Smart task creation & planning",
    proof_2_title: "Multilingual",
    proof_2_desc: "English, Hindi, Spanish & Arabic",
    proof_3_title: "Voice First",
    proof_3_desc: "Speak to manage work",
    
    // Auth
    login: "Login",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    login_title: "Welcome Back",
    register_title: "Create Account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    
    // Onboarding
    onboarding_title: "Let's set up your workspace",
    select_language: "Choose your language",
    select_mode: "Choose your mode",
    simple_mode: "Simple Mode",
    simple_mode_desc: "Minimal options, AI does the work",
    advanced_mode: "Advanced Mode",
    advanced_mode_desc: "Full control over everything",
    get_started: "Get Started",
    
    // Navigation
    dashboard: "Dashboard",
    projects: "Projects",
    tasks: "Tasks",
    chat: "AI Chat",
    agents: "AI Agents",
    reports: "Reports",
    settings: "Settings",
    logout: "Logout",
    teams: "Teams",
    
    // Teams
    new_team: "New Team",
    team_name: "Team Name",
    team_description: "Description",
    create_team: "Create Team",
    invite_member: "Invite Member",
    members: "Members",
    admin: "Admin",
    member: "Member",
    viewer: "Viewer",
    leave_team: "Leave Team",
    remove_member: "Remove Member",
    no_teams: "No teams yet",
    
    // Projects
    new_project: "New Project",
    project_name: "Project Name",
    project_description: "Description",
    create_project: "Create Project",
    no_projects: "No projects yet",
    create_first_project: "Create your first project to get started",
    personal_projects: "Personal Projects",
    team_projects: "Team Projects",
    
    // Tasks
    new_task: "New Task",
    task_title: "Task Title",
    task_description: "Description",
    priority: "Priority",
    status: "Status",
    due_date: "Due Date",
    assignee: "Assignee",
    tags: "Tags",
    create_task: "Create Task",
    ai_suggestions: "AI Suggestions",
    apply_suggestions: "Apply Suggestions",
    todo: "To Do",
    in_progress: "In Progress",
    done: "Done",
    low: "Low",
    medium: "Medium",
    high: "High",
    subtasks: "Subtasks",
    add_subtask: "Add Subtask",
    drag_to_reorder: "Drag to reorder",
    
    // Chat
    chat_placeholder: "Tell me what you want to do...",
    voice_input: "Voice Input",
    send: "Send",
    
    // AI Agents
    new_agent: "New Agent",
    agent_name: "Agent Name",
    agent_description: "Description",
    trigger_type: "Trigger Type",
    auto_assign: "Auto Assign",
    reminder: "Reminder",
    report: "Report",
    follow_up: "Follow Up",
    enabled: "Enabled",
    disabled: "Disabled",
    
    // Reports
    summary: "Summary",
    total_projects: "Total Projects",
    total_tasks: "Total Tasks",
    completed_this_week: "Completed This Week",
    productivity_score: "Productivity Score",
    ai_insights: "AI Insights",
    
    // Settings
    language_setting: "Language",
    mode_setting: "Mode",
    save_settings: "Save Settings",
    
    // Health Status
    on_track: "On Track",
    needs_attention: "Needs Attention",
    at_risk: "At Risk",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    undo: "Undo",
    close: "Close",
  },
  
  hi: {
    // Landing Page
    hero_title: "प्रोजेक्ट्स मैनेज करें। कुशलता से।",
    hero_subtitle: "आवाज़ या सरल भाषा से प्रोजेक्ट और टास्क बनाएं।",
    cta_primary: "AI से शुरू करें – मुफ़्त",
    cta_secondary: "डेमो देखें",
    proof_1_title: "AI-संचालित",
    proof_1_desc: "स्मार्ट टास्क निर्माण और प्लानिंग",
    proof_2_title: "बहुभाषी",
    proof_2_desc: "अंग्रेज़ी, हिंदी, स्पैनिश और अरबी",
    proof_3_title: "वॉयस फर्स्ट",
    proof_3_desc: "बोलकर काम मैनेज करें",
    
    // Auth
    login: "लॉगिन",
    register: "साइन अप",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "नाम",
    login_title: "वापसी पर स्वागत",
    register_title: "खाता बनाएं",
    no_account: "खाता नहीं है?",
    have_account: "पहले से खाता है?",
    
    // Onboarding
    onboarding_title: "अपना वर्कस्पेस सेट करें",
    select_language: "भाषा चुनें",
    select_mode: "मोड चुनें",
    simple_mode: "सिंपल मोड",
    simple_mode_desc: "कम विकल्प, AI काम करे",
    advanced_mode: "एडवांस मोड",
    advanced_mode_desc: "पूर्ण नियंत्रण",
    get_started: "शुरू करें",
    
    // Navigation
    dashboard: "डैशबोर्ड",
    projects: "प्रोजेक्ट्स",
    tasks: "टास्क",
    chat: "AI चैट",
    agents: "AI एजेंट्स",
    reports: "रिपोर्ट्स",
    settings: "सेटिंग्स",
    logout: "लॉगआउट",
    teams: "टीमें",
    
    // Teams
    new_team: "नई टीम",
    team_name: "टीम का नाम",
    team_description: "विवरण",
    create_team: "टीम बनाएं",
    invite_member: "सदस्य आमंत्रित करें",
    members: "सदस्य",
    admin: "एडमिन",
    member: "सदस्य",
    viewer: "दर्शक",
    leave_team: "टीम छोड़ें",
    remove_member: "सदस्य हटाएं",
    no_teams: "कोई टीम नहीं",
    
    // Projects
    new_project: "नया प्रोजेक्ट",
    project_name: "प्रोजेक्ट का नाम",
    project_description: "विवरण",
    create_project: "प्रोजेक्ट बनाएं",
    no_projects: "कोई प्रोजेक्ट नहीं",
    create_first_project: "शुरू करने के लिए अपना पहला प्रोजेक्ट बनाएं",
    personal_projects: "व्यक्तिगत प्रोजेक्ट्स",
    team_projects: "टीम प्रोजेक्ट्स",
    
    // Tasks
    new_task: "नया टास्क",
    task_title: "टास्क शीर्षक",
    task_description: "विवरण",
    priority: "प्राथमिकता",
    status: "स्थिति",
    due_date: "नियत तारीख",
    assignee: "असाइनी",
    tags: "टैग्स",
    create_task: "टास्क बनाएं",
    ai_suggestions: "AI सुझाव",
    apply_suggestions: "सुझाव लागू करें",
    todo: "करना है",
    in_progress: "प्रगति में",
    done: "पूर्ण",
    low: "कम",
    medium: "मध्यम",
    high: "उच्च",
    subtasks: "उप-कार्य",
    add_subtask: "उप-कार्य जोड़ें",
    drag_to_reorder: "क्रम बदलने के लिए खींचें",
    
    // Chat
    chat_placeholder: "बताएं आप क्या करना चाहते हैं...",
    voice_input: "आवाज़ इनपुट",
    send: "भेजें",
    
    // AI Agents
    new_agent: "नया एजेंट",
    agent_name: "एजेंट का नाम",
    agent_description: "विवरण",
    trigger_type: "ट्रिगर प्रकार",
    auto_assign: "ऑटो असाइन",
    reminder: "रिमाइंडर",
    report: "रिपोर्ट",
    follow_up: "फॉलो अप",
    enabled: "सक्रिय",
    disabled: "निष्क्रिय",
    
    // Reports
    summary: "सारांश",
    total_projects: "कुल प्रोजेक्ट्स",
    total_tasks: "कुल टास्क",
    completed_this_week: "इस हफ्ते पूर्ण",
    productivity_score: "उत्पादकता स्कोर",
    ai_insights: "AI अंतर्दृष्टि",
    
    // Settings
    language_setting: "भाषा",
    mode_setting: "मोड",
    save_settings: "सेटिंग्स सेव करें",
    
    // Health Status
    on_track: "सही राह पर",
    needs_attention: "ध्यान चाहिए",
    at_risk: "जोखिम में",
    
    // Common
    save: "सेव करें",
    cancel: "रद्द करें",
    delete: "हटाएं",
    edit: "संपादित करें",
    loading: "लोड हो रहा है...",
    error: "त्रुटि",
    success: "सफल",
    confirm: "पुष्टि करें",
    undo: "पूर्ववत करें",
    close: "बंद करें",
  },
  
  es: {
    // Landing Page
    hero_title: "Gestiona proyectos. Eficientemente.",
    hero_subtitle: "Crea proyectos y tareas usando voz o lenguaje simple.",
    cta_primary: "Empieza con AI – Gratis",
    cta_secondary: "Ver Demo",
    proof_1_title: "Impulsado por IA",
    proof_1_desc: "Creación inteligente de tareas",
    proof_2_title: "Multilingüe",
    proof_2_desc: "Inglés, Hindi, Español y Árabe",
    proof_3_title: "Voz Primero",
    proof_3_desc: "Habla para gestionar trabajo",
    
    // Auth
    login: "Iniciar Sesión",
    register: "Registrarse",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre",
    login_title: "Bienvenido de nuevo",
    register_title: "Crear Cuenta",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    
    // Onboarding
    onboarding_title: "Configuremos tu espacio",
    select_language: "Elige tu idioma",
    select_mode: "Elige tu modo",
    simple_mode: "Modo Simple",
    simple_mode_desc: "Opciones mínimas, la IA trabaja",
    advanced_mode: "Modo Avanzado",
    advanced_mode_desc: "Control total",
    get_started: "Empezar",
    
    // Navigation
    dashboard: "Panel",
    projects: "Proyectos",
    tasks: "Tareas",
    chat: "Chat IA",
    agents: "Agentes IA",
    reports: "Informes",
    settings: "Configuración",
    logout: "Cerrar Sesión",
    teams: "Equipos",
    
    // Teams
    new_team: "Nuevo Equipo",
    team_name: "Nombre del Equipo",
    team_description: "Descripción",
    create_team: "Crear Equipo",
    invite_member: "Invitar Miembro",
    members: "Miembros",
    admin: "Administrador",
    member: "Miembro",
    viewer: "Observador",
    leave_team: "Dejar Equipo",
    remove_member: "Eliminar Miembro",
    no_teams: "Sin equipos aún",
    
    // Projects
    new_project: "Nuevo Proyecto",
    project_name: "Nombre del Proyecto",
    project_description: "Descripción",
    create_project: "Crear Proyecto",
    no_projects: "Sin proyectos aún",
    create_first_project: "Crea tu primer proyecto para empezar",
    personal_projects: "Proyectos Personales",
    team_projects: "Proyectos de Equipo",
    
    // Tasks
    new_task: "Nueva Tarea",
    task_title: "Título de Tarea",
    task_description: "Descripción",
    priority: "Prioridad",
    status: "Estado",
    due_date: "Fecha Límite",
    assignee: "Asignado",
    tags: "Etiquetas",
    create_task: "Crear Tarea",
    ai_suggestions: "Sugerencias IA",
    apply_suggestions: "Aplicar Sugerencias",
    todo: "Por Hacer",
    in_progress: "En Progreso",
    done: "Hecho",
    low: "Baja",
    medium: "Media",
    high: "Alta",
    subtasks: "Subtareas",
    add_subtask: "Añadir Subtarea",
    drag_to_reorder: "Arrastra para reordenar",
    
    // Chat
    chat_placeholder: "Dime qué quieres hacer...",
    voice_input: "Entrada de Voz",
    send: "Enviar",
    
    // AI Agents
    new_agent: "Nuevo Agente",
    agent_name: "Nombre del Agente",
    agent_description: "Descripción",
    trigger_type: "Tipo de Disparador",
    auto_assign: "Auto Asignar",
    reminder: "Recordatorio",
    report: "Informe",
    follow_up: "Seguimiento",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    
    // Reports
    summary: "Resumen",
    total_projects: "Total Proyectos",
    total_tasks: "Total Tareas",
    completed_this_week: "Completadas esta semana",
    productivity_score: "Puntuación de Productividad",
    ai_insights: "Análisis IA",
    
    // Settings
    language_setting: "Idioma",
    mode_setting: "Modo",
    save_settings: "Guardar Configuración",
    
    // Health Status
    on_track: "En Camino",
    needs_attention: "Necesita Atención",
    at_risk: "En Riesgo",
    
    // Common
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    confirm: "Confirmar",
    undo: "Deshacer",
    close: "Cerrar",
  },
  
  ar: {
    // Landing Page
    hero_title: "أدر المشاريع. بكفاءة.",
    hero_subtitle: "أنشئ المشاريع والمهام باستخدام الصوت أو اللغة البسيطة.",
    cta_primary: "ابدأ مع AI – مجاناً",
    cta_secondary: "شاهد العرض",
    proof_1_title: "مدعوم بالذكاء",
    proof_1_desc: "إنشاء المهام الذكية",
    proof_2_title: "متعدد اللغات",
    proof_2_desc: "الإنجليزية والهندية والإسبانية والعربية",
    proof_3_title: "الصوت أولاً",
    proof_3_desc: "تحدث لإدارة العمل",
    
    // Auth
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    login_title: "مرحباً بعودتك",
    register_title: "إنشاء حساب",
    no_account: "ليس لديك حساب؟",
    have_account: "لديك حساب بالفعل؟",
    
    // Onboarding
    onboarding_title: "لنعد مساحة عملك",
    select_language: "اختر لغتك",
    select_mode: "اختر وضعك",
    simple_mode: "الوضع البسيط",
    simple_mode_desc: "خيارات قليلة، AI يعمل",
    advanced_mode: "الوضع المتقدم",
    advanced_mode_desc: "تحكم كامل",
    get_started: "ابدأ الآن",
    
    // Navigation
    dashboard: "لوحة التحكم",
    projects: "المشاريع",
    tasks: "المهام",
    chat: "دردشة AI",
    agents: "وكلاء AI",
    reports: "التقارير",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    teams: "الفرق",
    
    // Teams
    new_team: "فريق جديد",
    team_name: "اسم الفريق",
    team_description: "الوصف",
    create_team: "إنشاء فريق",
    invite_member: "دعوة عضو",
    members: "الأعضاء",
    admin: "مدير",
    member: "عضو",
    viewer: "مشاهد",
    leave_team: "مغادرة الفريق",
    remove_member: "إزالة العضو",
    no_teams: "لا توجد فرق",
    
    // Projects
    new_project: "مشروع جديد",
    project_name: "اسم المشروع",
    project_description: "الوصف",
    create_project: "إنشاء مشروع",
    no_projects: "لا توجد مشاريع",
    create_first_project: "أنشئ مشروعك الأول للبدء",
    personal_projects: "المشاريع الشخصية",
    team_projects: "مشاريع الفريق",
    
    // Tasks
    new_task: "مهمة جديدة",
    task_title: "عنوان المهمة",
    task_description: "الوصف",
    priority: "الأولوية",
    status: "الحالة",
    due_date: "تاريخ الاستحقاق",
    assignee: "المسؤول",
    tags: "العلامات",
    create_task: "إنشاء مهمة",
    ai_suggestions: "اقتراحات AI",
    apply_suggestions: "تطبيق الاقتراحات",
    todo: "للعمل",
    in_progress: "قيد التنفيذ",
    done: "مكتمل",
    low: "منخفض",
    medium: "متوسط",
    high: "عالي",
    subtasks: "المهام الفرعية",
    add_subtask: "إضافة مهمة فرعية",
    drag_to_reorder: "اسحب لإعادة الترتيب",
    
    // Chat
    chat_placeholder: "أخبرني ماذا تريد أن تفعل...",
    voice_input: "إدخال صوتي",
    send: "إرسال",
    
    // AI Agents
    new_agent: "وكيل جديد",
    agent_name: "اسم الوكيل",
    agent_description: "الوصف",
    trigger_type: "نوع المشغل",
    auto_assign: "تعيين تلقائي",
    reminder: "تذكير",
    report: "تقرير",
    follow_up: "متابعة",
    enabled: "مفعل",
    disabled: "معطل",
    
    // Reports
    summary: "ملخص",
    total_projects: "إجمالي المشاريع",
    total_tasks: "إجمالي المهام",
    completed_this_week: "مكتمل هذا الأسبوع",
    productivity_score: "درجة الإنتاجية",
    ai_insights: "رؤى AI",
    
    // Settings
    language_setting: "اللغة",
    mode_setting: "الوضع",
    save_settings: "حفظ الإعدادات",
    
    // Health Status
    on_track: "على المسار",
    needs_attention: "يحتاج اهتمام",
    at_risk: "في خطر",
    
    // Common
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجاح",
    confirm: "تأكيد",
    undo: "تراجع",
    close: "إغلاق",
  },
};

export const useTranslation = (language = 'en') => {
  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };
  return { t };
};

export const languageNames = {
  en: { name: 'English', native: 'English', flag: '🇺🇸' },
  hi: { name: 'Hindi', native: 'हिन्दी', flag: '🇮🇳' },
  es: { name: 'Spanish', native: 'Español', flag: '🇪🇸' },
  ar: { name: 'Arabic', native: 'العربية', flag: '🇸🇦', rtl: true },
};
